import { render, staticRenderFns } from "./ErrorPageLayout.vue?vue&type=template&id=15f21a58&scoped=true"
import script from "./ErrorPageLayout.vue?vue&type=script&lang=js"
export * from "./ErrorPageLayout.vue?vue&type=script&lang=js"
import style0 from "./ErrorPageLayout.vue?vue&type=style&index=0&id=15f21a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f21a58",
  null
  
)

export default component.exports